import React from "react";
import PropTypes from "prop-types";
import {
  advancedFilterWorker,
  tableSkeleton
} from "../../../constant/helper/helper";
import ShowDateList from "./ShowDateList";
import { Link } from "react-router-dom";
import useSortableData from "../../../customHooks/sortingHooks";
import { tableHeaderData } from "./sheetStaticData";
import TableHeader from "../../../component/tableHeader/TableHeader";
import isEmpty from "../../../validation/isEmpty";

// import Pagination from "react-bootstrap/Pagination";

const AttendanceUserList = ({
  values,
  loading,
  loginType,
  dateArrayState,
  attendanceSheetData,
  dateDifference,
  searchTerm,
  currentPage,
  setCurrentPage,
  zone
}) => {
  const onHeaderChange = () => {
    return dateArrayState.map((dateRange, dateRangeIndex) => (
      <th
        key={dateRangeIndex}
        className="text-center"
        colSpan={values.dataFormat === "ABP" ? "1" : "2"}
      >
        {dateRange}
      </th>
    ));
  };

  const showUserList = (sheetData) => {
    if (loading) {
      return <tr>{tableSkeleton(27 + Number(dateDifference))}</tr>;
    } else if (!isEmpty(sheetData)) {
      let newSortedArray = sheetData;
      if (!isEmpty(zone)) {
        newSortedArray = sheetData.filter((filterWorker) => {
          return filterWorker.zoneId.indexOf(zone) !== -1;
        });
      }

      const filterEmployees = advancedFilterWorker(
        newSortedArray,
        values.Filter,
        "fullNameAndId"
      );

      return filterEmployees.map((mapData, parentIndex) => {
        return (
          <tr key={parentIndex} style={{ fontSize: 12 }}>
            <td>{parentIndex + 1}</td>
            <td style={{ fontSize: 12 }}>{mapData.workerId}</td>
            <td className="table-user">
              <span className="text-body font-weight-semibold">
                <Link to={`/hr/user/all-users/${mapData.employeeId}`}>
                  {mapData.workerFullName}
                </Link>
              </span>
            </td>
            <td style={{ fontSize: 12 }}>
              {mapData.workerDepartment}
            </td>
            <td style={{ fontSize: 12 }}>
              {mapData.workerDesignation}
            </td>
            <td className="text-center" style={{ fontSize: 12 }}>
              {mapData.Location}
            </td>
            <td className="text-center" style={{ fontSize: 12 }}>
              {loginType}
            </td>
            <ShowDateList
              dayList={mapData.dailyPointsArray}
              values={values}
            />
            <td className="table-action text-center">
              <span className="text-dark">
                {Math.round(mapData.TotalWeekOf)}
              </span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">
                {Math.round(mapData.TotalWop)}
              </span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">
                {Math.round(mapData.TotalAbsent)}
              </span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">{mapData.TotalOd}</span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">{mapData.TotalLc}</span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">{mapData.TotalEo}</span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">{mapData.TotalHd}</span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">{mapData.TotalPl}</span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">{mapData.TotalNbl}</span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">{mapData.TotalPtl}</span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">{mapData.TotalMtl}</span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">{mapData.TotalBl}</span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">{mapData.TotalCo}</span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">{mapData.TotalOh}</span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">{mapData.TotalPh}</span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">{mapData.TotalOT}</span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">{mapData.TotalAml}</span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">
                {mapData.TotalPresent}
              </span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">
                {Math.round(mapData.TotalWeekOf) +
                  Math.round(mapData.TotalWop) +
                  Math.round(mapData.TotalOd) +
                  Math.round(mapData.TotalLc) +
                  Math.round(mapData.TotalEo) +
                  Math.round(mapData.TotalPl) +
                  Math.round(mapData.TotalNbl) +
                  Math.round(mapData.TotalPtl) +
                  Math.round(mapData.TotalMtl) +
                  Math.round(mapData.TotalBl) +
                  Math.round(mapData.TotalCo) +
                  Math.round(mapData.TotalOh) +
                  Math.round(mapData.TotalPh) +
                  Math.round(mapData.TotalAml) +
                  Math.round(mapData.TotalPresent) +
                  Math.round(mapData.TotalOT) * 2 +
                  Math.round(mapData.TotalHd) / 2}
              </span>
            </td>
          </tr>
        );
      });
    } else if (sheetData === null) {
      return (
        <tr style={{ top: "50%", left: "50%", position: "fixed" }}>
          <td>
            <span className="">
              Please Select From Date, To Date and Location
            </span>
          </td>
        </tr>
      );
    } else if (sheetData.length === 0) {
      return (
        <tr style={{ top: "50%", left: "50%", position: "fixed" }}>
          <td>
            <span className=""> No Record Found</span>
          </td>
        </tr>
      );
    }
  };

  const { items, requestSort, sortConfig } = useSortableData(
    attendanceSheetData
  );
  // Filter the data based on the search term
  const filterEmployees = advancedFilterWorker(
    items,
    searchTerm,
    "fullNameAndId"
  );

  const itemsPerPage =
    values.exportFullData === "YES"
      ? Number(filterEmployees.length)
      : 50;
  const totalPages = Math.ceil(filterEmployees.length / itemsPerPage);

  // Calculate the indexes of the items to be displayed on the current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Get the data for the current page
  const currentPageData = filterEmployees.slice(startIndex, endIndex);

  // Handle pagination navigation
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const renderPaginationButtons = () => {
    const totalButtons = 6; // Number of buttons to show on both sides of the current page
    const rangeStart = currentPage - Math.floor(totalButtons / 2);
    const rangeEnd = currentPage + Math.floor(totalButtons / 2);
    const buttons = [];

    for (let i = rangeStart; i <= rangeEnd; i++) {
      if (i > 0 && i <= totalPages) {
        buttons.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            disabled={currentPage === i}
            style={{
              fontWeight: currentPage === i ? "bold" : "normal",
              backgroundColor: currentPage === i ? "blue" : "white",
              color: currentPage === i ? "white" : "black",
              border: "1px solid gray",
              borderRadius: "5px",
              padding: "5px 10px",
              margin: "0 5px",
              cursor: "pointer"
            }}
          >
            {i}
          </button>
        );
      }
    }

    return buttons;
  };

  return (
    <div>
      <div
        className="table-responsive"
        style={{ height: "700px", overflow: "auto" }}
      >
        <table
          className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
          id="products-datatable"
        >
          <thead className="thead-light">
            <tr>
              <th style={{ width: "20px" }}>#</th>
              <TableHeader
                tableHeaderData={tableHeaderData}
                requestSort={requestSort}
                sortConfig={sortConfig}
              />

              <th className="text-center">Type</th>
              {onHeaderChange()}
              <th className="text-center">WO</th>
              <th className="text-center">WOP</th>
              <th className="text-center">AB</th>
              <th className="text-center">OD</th>
              <th className="text-center">LC</th>
              <th className="text-center">EO</th>
              <th className="text-center">HD</th>
              <th className="text-center">PL</th>
              <th className="text-center">NBL</th>
              <th className="text-center">PTL</th>
              <th className="text-center">MTL</th>
              <th className="text-center">BL</th>
              <th className="text-center">CO</th>
              <th className="text-center">OH</th>
              <th className="text-center">PH</th>
              <th className="text-center">OT</th>
              <th className="text-center">AML</th>
              <th className="text-center">P</th>
              <th className="text-center">Total</th>
            </tr>
          </thead>
          <tbody>{showUserList(currentPageData)}</tbody>
        </table>
      </div>
      {/* Render pagination buttons */}
      <div className="row mt-2">
        <div className="col-lg-12">
          {/* <div style={{ alignItems: "center" }}>
          {Array.from(
            { length: Math.ceil(items.length / itemsPerPage) },
            (_, i) => {
              const pageNumber = i + 1;
              return (
                <button
                  key={i}
                  onClick={() => goToPage(i + 1)}
                  disabled={currentPage === pageNumber}
                  style={{
                    fontWeight:
                      currentPage === pageNumber ? "bold" : "normal",
                    backgroundColor:
                      currentPage === pageNumber ? "blue" : "white",
                    color:
                      currentPage === pageNumber ? "white" : "black",
                    border: "1px solid gray",
                    borderRadius: "5px",
                    padding: "5px 10px",
                    margin: "0 5px",
                    cursor: "pointer"
                  }}
                >
                  {i + 1}
                </button>
              );
            }
          )}
        </div> */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px"
            }}
          >
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                fontWeight: "bold",
                backgroundColor: "blue",
                color: "white",
                border: "1px solid gray",
                borderRadius: "5px",
                padding: "5px 10px",
                margin: "0 5px",
                cursor: "pointer"
              }}
            >
              Previous
            </button>
            {renderPaginationButtons()}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              style={{
                fontWeight: "bold",
                backgroundColor: "blue",
                color: "white",
                border: "1px solid gray",
                borderRadius: "5px",
                padding: "5px 10px",
                margin: "0 5px",
                cursor: "pointer"
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

AttendanceUserList.propTypes = {
  loading: PropTypes.bool,
  values: PropTypes.object.isRequired,
  attendanceSheetData: PropTypes.array,
  loginType: PropTypes.string.isRequired,
  dateArrayState: PropTypes.array.isRequired,
  dateDifference: PropTypes.number.isRequired,
  searchTerm: PropTypes.string.isRequired,
  currentPage: PropTypes.string.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  zone: PropTypes.string.isRequired
};

export default AttendanceUserList;
